export enum ResidentSourceType {
  EIQ = 'EIQ',
  NorthStar = 'NorthStar',
  Jonas = 'Jonas',
}
